import { orderBy, where } from 'firebase/firestore';
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import logo from '../../../../assets/img/logo_uget_black.png';
import BtnLoad from '../../../../components/MyCustom/BtnLoad';
import SelectEstablishment from '../../../../components/MyCustom/SelectEstablishment';
import TableCustom from '../../../../components/MyCustom/TableCustom';
import Breadcrumb from '../../../../components/bootstrap/Breadcrumb';
import Button from '../../../../components/bootstrap/Button';
import Card, { CardBody } from '../../../../components/bootstrap/Card';
import Input from '../../../../components/bootstrap/forms/Input';
import ModalImportProducts from '../../../../components/modals/Ifood/ModalImportProducts';
import ModalPriceUpdatePreview from '../../../../components/modals/Products/ModalPriceUpdatePreview';
import ModalRegisterProducts from '../../../../components/modals/Products/ModalRegister';
import { DefaultContext } from '../../../../contexts/default';
import ProductDB from '../../../../database/wrappers/product';
import SuggestionDB from '../../../../database/wrappers/suggestion';
import Money from '../../../../helpers/utils/money/money';
import PreAlert from '../../../../helpers/utils/preAlert';
import Page from '../../../../layout/Page/Page';
import PageWrapper from '../../../../layout/PageWrapper/PageWrapper';
import SubHeader, { SubHeaderLeft, SubHeaderRight } from '../../../../layout/SubHeader/SubHeader';
import { demoPages } from '../../../../menu';
import { ACCESS_LEVEL } from '../../../../types/roles';
import convertArrayToObject from '../../../../utils/convertArrayToObject';
import ImportProductCsv from '../../../../utils/csv/importProductCsv';
import { convertIdToDecimal } from '../../../../utils/everest/export';
import useProductPriceImport from './hooks/useProductPriceImport';

const Products = () => {
  const { accessLevel, establishment, estabSelected, onShowAlert } = useContext(DefaultContext)

  const [openModalRegister, setOpenModalRegister] = useState(false);
  const [products, setProducts] = useState([])
  const [productSelected, setProductSelected] = useState({});
  const [loadImport, setloadImport] = useState(false);
  const [suggestionsDicionary, setsuggestionsDicionary] = useState({})
  const [ifoodImport, setIfoodImport] = useState(false)

  const inputFile = useRef(null)
  const refLinkProduct = useRef(null)

  const {
    inputPriceFile,
    loadImportPrices,
    savingPrices,
    openPricePreviewModal,
    pricePreviewRows,
    invalidPriceRows,
    setOpenPricePreviewModal,
    handleClickImportPrices,
    handleImportPriceFile,
    handleConfirmPriceUpdate,
    handleClosePricePreviewModal,
  } = useProductPriceImport({
    establishmentId: establishment ? establishment.id : null,
    products,
    onShowAlert,
  });

  useEffect(() => {
    if (!establishment) return;
    const onSubscribe = new ProductDB(establishment.id).on(setProducts, orderBy('name', 'asc'));
    const onSubscribe2 = new SuggestionDB(establishment.id).on(datas => setsuggestionsDicionary(convertArrayToObject(datas, 'id')), where('active', '==', true));

    return () => {
      onSubscribe();
      onSubscribe2();
    };
  }, [establishment])

  const handleFiles = useCallback(e => {
    if (!estabSelected) return;
    setloadImport(true)
    const [file] = Array.from(e.target.files)
    new ImportProductCsv(estabSelected)
      .import(file)
      .then(({ updated, created, removed }) => onShowAlert(PreAlert.success(
        `${updated} produto(s) atualizado(s). ${created} criado(s) e ${removed} excluído(s).`
      )))
      .catch((error) => onShowAlert(PreAlert.error(error?.message || error || 'Falhou ao atualizar o(s) produto(s)')))
      .finally(() => {
        setloadImport(false)
        e.target.value = ''
      })
  }, [estabSelected, onShowAlert])

  const onClickImport = useCallback(() => {
    inputFile.current.click();
  }, [inputFile])

  const onDownloadProductCsv = useCallback(() => {
    refLinkProduct.current.click();
  }, [refLinkProduct])

  const handleOpenModalRegister = useCallback(() => {
    setProductSelected(null)
    setOpenModalRegister(true);
  }, [])

  const handleCloseModalRegister = useCallback(() => {
    setOpenModalRegister(false);
  }, [])

  const handleOpenModalEdit = useCallback((item) => {
    const productToEdit = {
      ...item,
      price: item.price.toFixed(2).toString(),
      products: item.products.map(product => ({ ...product, qtd: product.qtd.toFixed(2).toString(), unit_value: product.unit_value.toFixed(2).toString() }))
    }

    setProductSelected(productToEdit);
    setOpenModalRegister(true)
  }, [])


  // const handleOpenModalDelete = useCallback((id) => {
  //   onShowQuestion({
  //     title: 'Exclusão de Produto',
  //     message: 'Você está excluindo um produto. Está ação é irreversível. Deseja continuar?',
  //     onConfirm: () => {
  //       new ProductDB(establishment.id)
  //         .delete(id)
  //         .then(res => showNotification('', notificationBody('Registro deletado com sucesso'), 'success'))
  //         .catch(err => showNotification('', notificationBody('Falhou ao deletar o registro'), 'danger'))
  //     }
  //   })
  // }, [establishment])


  const handleChangeStatus = useCallback((id, active) => {
    new ProductDB(establishment.id)
      .update(id, {
        active: !active
      })
      .catch(error => onShowAlert({
        title: 'ERRO!',
        msm: 'Não foi possível atualizar o status do produto',
        icon: 'Error',
        color: 'danger'
      }))
  }, [establishment])

  const handleIfoodImport = () => setIfoodImport(!ifoodImport)

  const rowsRender = useMemo(() => products.map(item => {
    const fiscalData = (item.fiscal_data && typeof item.fiscal_data === 'object') ? item.fiscal_data : {};
    return {
      ...item,
      fiscal_bar_code: fiscalData.bar_code,
      fiscal_ncm: fiscalData.ncm,
      fiscal_cst: fiscalData.cst,
      fiscal_csosn: fiscalData.csosn,
      fiscal_cest: fiscalData.cest,
      fiscal_cfop: fiscalData.cfop,
      fiscal_aliq_icms: fiscalData.aliq_icms,
      fiscal_cBenef: fiscalData.cBenef,
      fiscal_tributary_situation: fiscalData.tributary_situation,
      fiscal_pis: fiscalData.pis,
      fiscal_cofins: fiscalData.cofins,
      fiscal_cClassTrib: fiscalData.cClassTrib,
      fiscal_cst_cbs_ibs: fiscalData.cst_cbs_ibs,
      fiscal_percentualReducao: fiscalData.percentualReducao,
    };
  }), [products])

  const columns = useMemo(() => ([
    {
      label: 'id',
      field: 'id',
      hidden: true
    },
    {
      label: 'Imagem',
      field: 'image_url',
      format: row => (
        <>
          {row.image_url ? (
            <img src={row.image_url} alt="Imagem" width={54} height={54} />
          ) : (
            <img src={logo} alt="Imagem" width={60} height='auto' />
          )}
        </>

      ),
      noExport: true,
    },
    {
      label: 'Nome',
      field: 'name',
    },
    {
      label: 'Ordem',
      field: 'order',
      format: row => row.order ?? null,
    },
    {
      label: 'Preço',
      field: 'price',
      format: row => Money.centsToMaskMoney(row.price),
      isCurrency: true
    },
    {
      label: 'Cod. Interno',
      field: 'internalCode',
    },
    {
      label: 'Cod. Barra',
      field: 'fiscal_bar_code',
      hidden: true
    },
    {
      label: 'NCM',
      field: 'fiscal_ncm',
      hidden: true
    },
    {
      label: 'CST',
      field: 'fiscal_cst',
      hidden: true
    },
    {
      label: 'CSOSN',
      field: 'fiscal_csosn',
      hidden: true
    },
    {
      label: 'CEST',
      field: 'fiscal_cest',
      hidden: true
    },
    {
      label: 'CFOP',
      field: 'fiscal_cfop',
      hidden: true
    },
    {
      label: 'ICMS',
      field: 'fiscal_aliq_icms',
      hidden: true
    },
    {
      label: 'Cód. Benefício Fiscal',
      field: 'fiscal_cBenef',
      hidden: true
    },
    {
      label: 'SIT. Tributaria',
      field: 'fiscal_tributary_situation',
      hidden: true
    },
    {
      label: 'PIS',
      field: 'fiscal_pis',
      hidden: true
    },
    {
      label: 'COFINS',
      field: 'fiscal_cofins',
      hidden: true
    },
    {
      label: 'Classificação Tributária CBS/IBS',
      field: 'fiscal_cClassTrib',
      hidden: true
    },
    {
      label: 'CST CBS/IBS',
      field: 'fiscal_cst_cbs_ibs',
      hidden: true
    },
    {
      label: 'Percentual de Redução',
      field: 'fiscal_percentualReducao',
      hidden: true
    },
    {
      label: 'Código Externo',
      field: 'externalCode ',
      hidden: true
    },
    {
      label: 'Tipo',
      field: 'type',
      hidden: true
    },
    {
      label: 'Unidade',
      field: 'unit',
      hidden: true
    },
    {
      label: 'Sugestão',
      field: 'suggestionId',
      format: row => !row.suggestionId ? ' ' : suggestionsDicionary[row.suggestionId]?.name || ' ',
      formatExport: value => !value ? ' ' : suggestionsDicionary[value]?.name || ' ',
    },
    {
      label: 'Status',
      field: 'active',
      format: row => (
        <>
          <Button
            isLink
            color={row.active ? 'success' : 'danger'}
            icon='Circle'
            onClick={() => handleChangeStatus(row.id, row.active)}
            className='text-nowrap'>
            {row.active ? 'Ativo' : 'Inativo'}
          </Button>
        </>
      ),
      formatExport: value => value ? 'Ativo' : 'Inativo'
    },
    {
      label: 'Id-everest',
      field: '{row}',
      format: row => convertIdToDecimal(row.id, 40),
      formatExport: row => convertIdToDecimal(row.id, 40),
      hidden: true
    },
    {
      label: 'Ações',
      field: 'actions',
      format: row => (
        <div className='w-50 d-flex justify-content-between'>
          <Button
            color="light"
            icon="edit"
            shadow="sm"
            hoverShadow="sm"
            size="sm"
            onClick={() => handleOpenModalEdit(row)}
          />

          {/* <Button
            color="danger"
            icon="Trash"
            shadow="sm"
            hoverShadow="sm"
            size="sm"
            onClick={() => handleOpenModalDelete(row.id)}
          /> */}
        </div>
      ),
      noExport: true
    },
  ]), [handleChangeStatus, handleOpenModalEdit, suggestionsDicionary])


  return (
    <>
      <PageWrapper title={demoPages.pdvMenu.subMenu.product.text}>
        <SubHeader>
          <SubHeaderLeft>
            <Breadcrumb
              list={[
                { title: 'Cadastros', to: '/pdv/products' },
                {
                  title: 'Produtos',
                  to: '/pdv/products',
                },
              ]}
            />
          </SubHeaderLeft>
          <SubHeaderRight>
            {accessLevel >= ACCESS_LEVEL.MANAGER && <>
              <a hidden ref={refLinkProduct} href='https://firebasestorage.googleapis.com/v0/b/e-pdx-b9d3b.appspot.com/o/ExtraFiles%2Fprodutos.csv?alt=media&token=cc7d8b28-db17-444a-9ac7-09e3fb1aaf0f' />
              <Button
                type='file'
                className='text-dark'
                color='success'
                icon='download'
                shadow="sm"
                hoverShadow="sm"
                onClick={onDownloadProductCsv}
              >
                Download CSV
              </Button>
              <Input
                hidden
                id='input-file-import'
                type='file'
                accept={'.csv'}
                ref={inputFile}
                onChange={handleFiles}
              />
              <Input
                hidden
                id='input-file-import-price-xlsx'
                type='file'
                accept={'.xlsx'}
                ref={inputPriceFile}
                onChange={handleImportPriceFile}
              />
              {loadImport ?
                <BtnLoad />
                :
                <Button
                  type='file'
                  className='text-dark'
                  color='warning'
                  icon='upload'
                  shadow="sm"
                  hoverShadow="sm"
                  onClick={onClickImport}
                >
                  Atualizar via CSV
                </Button>
              }
              {loadImportPrices ?
                <BtnLoad />
                :
                <Button
                  type='file'
                  className='text-dark'
                  color='success'
                  icon='upload'
                  shadow="sm"
                  hoverShadow="sm"
                  onClick={handleClickImportPrices}
                >
                  Importar Preços
                </Button>
              }
              <Button
                color='primary'
                icon='plus'
                shadow="sm"
                hoverShadow="sm"
                onClick={handleOpenModalRegister}
              >
                Cadastrar
              </Button>
            </>}
          </SubHeaderRight>
        </SubHeader>
        <Page container='fluid'>
          <Card>
            <CardBody className='table-responsive p-5'>
              <div className='row'>
                <SelectEstablishment />
              </div>
              <TableCustom
                columns={columns}
                rows={rowsRender}
                keyExtractor={item => item.id}
                fileName={'Produtos'}
              />
            </CardBody>
          </Card>
        </Page>
      </PageWrapper>

      <ModalRegisterProducts
        open={openModalRegister}
        setIsOpen={setOpenModalRegister}
        setIsClose={handleCloseModalRegister}
        productSelected={productSelected}
      />
      <ModalImportProducts
        open={ifoodImport}
        setIsOpen={handleIfoodImport}
        setIsClose={handleIfoodImport}
      />
      <ModalPriceUpdatePreview
        open={openPricePreviewModal}
        setIsOpen={setOpenPricePreviewModal}
        setIsClose={handleClosePricePreviewModal}
        rows={pricePreviewRows}
        invalidRows={invalidPriceRows}
        onConfirm={handleConfirmPriceUpdate}
        loading={savingPrices}
      />
    </>
  );
};

export default Products;
